<div
  class="mb-4 flex flex-col gap-2"
  (click)="onContainerClick($event)">
  <div class="grid grid-cols-3 gap-6 pt-4">
    <app-filter-product-search
      [label]="isArabic() ? 'المورد' : 'Supplier'"
      [placeholder]="isArabic() ? 'أدخل اسم المورد...' : 'Enter supplier name...'"
      [loading]="titleLoading()"
      [error]="titleError()"
      [results]="titleResults()"
      [(searchTerm)]="supplierTitle"
      [(showDropdown)]="showTitleDropdown"
      (searchChange)="onTitleSearchChange($event)"
      (selectItem)="onTitleSelect($event)" />

    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ الإنشاء (من)' : 'Created On (From)'"
      [(value)]="createdOnFrom"
      [isInvalid]="createdDateInvalid()" />

    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ الإنشاء (إلى)' : 'Created On (To)'"
      [(value)]="createdOnTo"
      [isInvalid]="createdDateInvalid()" />
  </div>

  <div class="section-border mt-4 flex justify-between border-t pt-4 pb-4">
    <app-filter-sorting-component
      [(orderBy)]="orderBy"
      [orderDir]="orderDir()"
      [sortOptions]="sortOptions"
      (toggleOrder)="onToggleSortOrder()" />

    <div class="flex items-end justify-end gap-3">
      <button
        (click)="onResetFilters()"
        class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-5 py-1.5 text-[13px] font-[500] hover:cursor-pointer">
        <span i18n="@@adminProductsResetButton">Clear</span>
      </button>
      <button
        (click)="onApplyFilters()"
        class="bg-primary hover-bg-primary-hover rounded-[6px] px-5 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer">
        <span i18n="@@submit">Submit</span>
      </button>
    </div>
  </div>
</div>
